export const types: OptionType[] = [
  { value: '', label: 'All Types' },
  { value: 'email', label: 'Email' },
  { value: 'product_info', label: 'Product Info' },
  { value: 'sms', label: 'SMS' },
  { value: 'phone', label: 'Phone' },
  { value: 'orchestrator_system', label: 'Orchestrator System' },
  {
    value: 'orchestrator_validation_schema',
    label: 'Orchestrator Validation Schema',
  },
  {
    value: 'communicator_validator',
    label: 'SMS/Email validator',
  },
  { value: 'campaign_strategy', label: 'Campaign Strategy' },
];

export const DRIVING_PROMPT_TYPES = new Set<string>([
  'orchestrator_system',
  'email',
  'sms',
  'phone',
  'communicator_validator',
]);

export const isDrivingPromptType = (promptType?: string | null): boolean =>
  !!promptType && DRIVING_PROMPT_TYPES.has(promptType);
